<template>
<div class="chapter">
<div class="inner_page">
<p class="centerx"><a id="page_i"></a><em>Other Books by Rebecca McClanahan</em></p>
<p class="imagec"><img alt="image" src="images/common.jpg"/></p>
<p class="centery">Mother Tongue</p>
<p class="centery">Mrs. Houdini</p>
<p class="centery">One Word Deep: Lectures and Readings</p>
<p class="centery">The Intersection of X and Y</p>
<p class="centery">Word Painting: A Guide to Writing More Descriptively</p>
<p class="centery">Naked as Eve</p>
<p class="centery">Write Your Heart Out</p>
<p class="centery">The Riddle Song and Other Rememberings</p>
<p class="centery">Deep Light: New and Selected Poems</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm1.vue?ea449026